import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export enum GameEnum {
  GreedyBox = 'GreedyBox',
  GreedyHiya = 'GreedyHiya',
  TeenPatti = 'TeenPatti',
}

export enum PageTypeEnum {
  task = 1,
  rank = 2,
}
export enum stageStatusEnum {
  '未完成' = 0,
  '完成未领' = 1,
  '完成并领' = 2,
}

export enum RankTypeEnum {
  thisweek = 1,
  // lastweek = 2,  // 第二期上
  rule = 3,
}

// 获取活动基础数据 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=35770757

export const lucky_game_get_activity_info = createAsyncThunk(
  'lucky_game_get_activity_info',
  async (activity_id: number, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'activity_expire'>>
    >('/live/commonactivity/get_activity_info', {
      activity_id,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
// 获取任务即个人信息 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=31613095
export const lucky_game_king_job_list = createAsyncThunk(
  'lucky_game_king_job_list',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'count_down'
          | 'score'
          | 'progress_max'
          | 'job_list'
          | 'reward_one_status'
          | 'reward_two_status'
          | 'reward_list'
        >
      >
    >('/live/activity/lucky_game_king_job_list', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
// h5 获取获奖记录 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=31613004
export const lucky_game_king_award = createAsyncThunk(
  'lucky_game_king_award',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<Pick<InitialStateType, 'award_list'>>>(
      '/live/activity/lucky_game_king_award',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)
// h5 获取奖励接口 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=31613061
export const lucky_game_king_get_reward = createAsyncThunk(
  'lucky_game_king_get_reward',
  async (arg: {reward_type: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'desc' | 'image'>>
    >('/live/activity/lucky_game_king_get_reward', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
// 获取榜单奖励页面 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41429888
export const lucky_game_king_get_rank_page_reward_list = createAsyncThunk(
  'lucky_game_king_get_rank_page_reward_list',
  async (arg: {rank_id: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'desc' | 'image'>>
    >(
      '/live/commonactivity/get_rank_page_reward_list',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export interface UserListItemData {
  member: {
    name: string
    mid: number
    zy_id: string
    avatar: string
  }
  rank_no: number
  score: number
}
// 接口数据配置
interface HiyaRes<T> {
  ret: number
  data: T
}
interface JobInfoType {
  // 任务id
  jobId: number
  // 任务描述
  desc: string
  // 任务需要完成的次数
  cnt: number
  // 0是未完成，1 是已完成
  status: number
  //  游玩游戏的次数
  play_cnt: number
}
interface AwardItemType {
  date: string
  award: string
}
interface RewardItemType {
  desc: string
  image: string
  reward_id: number
}

interface reward_item_type {
  ranks: Array<number>
  item_list: Array<{img: string; desc: string}>
}
interface InitialStateType {
  count_down?: number
  score?: number
  progress_max?: Array<number>
  job_list?: Array<JobInfoType>
  reward_one_status?: number
  reward_two_status?: number
  award_list?: Array<AwardItemType>
  // reward_list?: Array<RewardItemType>
  desc?: string
  image?: string
  reward_list?: Array<reward_item_type>
  gameType: GameEnum
  activity_expire?: number
}
const initialState: InitialStateType = {
  gameType: GameEnum.GreedyBox,
}
export const LuckRankSlice = createSlice({
  name: 'LuckRank',
  initialState,
  reducers: {
    changeGameType: (state, action: PayloadAction<GameEnum>) => {
      Object.assign(state, {
        gameType: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      lucky_game_king_get_rank_page_reward_list.fulfilled,
      (state, action) => {
        Object.assign(state, action.payload)
      }
    )
    builder.addCase(lucky_game_get_activity_info.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default LuckRankSlice.reducer
export const LuckRankActions = LuckRankSlice.actions
